import debounce from 'lodash/debounce'

const SELECTORS = Selectors({
  fader: '[data-fader]',
  active: 'is-active'
})

const props = {
  $faders: document.querySelectorAll(SELECTORS.fader),
  activeFaders: []
}

const fn = {
  init: () => {
    Array.from(props.$faders)
      .filter($el => $el.children.length > 1)
      .forEach($el => fn.setupFader($el))

    fn.bindEvents()
  },

  bindEvents: () => {
    window.addEventListener('resize', debounce(() => {
      props.activeFaders.forEach($el => fn.resize($el))
    }, 250))
  },

  setupFader: ($el) => {
    props.activeFaders.push($el)
    fn.resize($el)
    fn.start($el)
    $el.classList.add('is-init')
  },

  start: ($el) => {
    setInterval(() => {
      const $current = $el.querySelector(SELECTORS.asClass('active'))
      const $next = $current.nextElementSibling ? $current.nextElementSibling : $el.children[0]

      $current.classList.remove(SELECTORS.active)
      $next.classList.add(SELECTORS.active)
    }, 6000)
  },

  resize: ($el) => {
    const tallestHeight = Math.max.apply(null, Array.from($el.children).map($x => $x.getBoundingClientRect().height))
    $el.style.height = `${tallestHeight}px`
  }
}

export default {
  can: () => props.$faders.length,
  run: fn.init
}
